import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@makeably/creativex-design-system';
import styles from './Collapsible.module.css';

const propTypes = {
  children: PropTypes.node,
  header: PropTypes.node.isRequired,
  isInitiallyOpen: PropTypes.bool,
  useHeaderClick: PropTypes.bool,
};

const defaultProps = {
  children: undefined,
  isInitiallyOpen: false,
  useHeaderClick: false,
};

function renderHeader(header) {
  if (typeof header === 'string') {
    return <h5>{ header }</h5>;
  }

  return header;
}

function Collapsible({
  children,
  header,
  isInitiallyOpen,
  useHeaderClick,
}) {
  const [isOpen, setIsOpen] = useState(isInitiallyOpen);
  const toggleOpen = () => setIsOpen((last) => !last);

  return (
    <div>
      <div className="u-flexRow u-justifyBetween u-alignStretch">
        <button
          className={`${styles.header} ${useHeaderClick ? styles.clickable : ''}`}
          type="button"
          onClick={useHeaderClick ? toggleOpen : null}
        >
          { renderHeader(header) }
        </button>
        <div className="u-flexColumn u-justifyCenter u-paddingRight-16">
          <Button
            iconLeft={isOpen ? 'chevronDown' : 'chevronRight'}
            variant="round"
            onClick={toggleOpen}
          />
        </div>
      </div>
      <div className={`${styles.content} ${isOpen ? styles.open : ''}`}>
        <div className={styles.children}>
          { children }
        </div>
      </div>
    </div>
  );
}

Collapsible.propTypes = propTypes;
Collapsible.defaultProps = defaultProps;

export default Collapsible;
